import React, { useEffect, useMemo, useState } from "react";
import { Container, Button, Modal, ModalHeader, ModalBody, ModalFooter, Input, Label, Card, CardBody, Table, Row, Col, UncontrolledTooltip, FormGroup, Form } from "reactstrap";
import { Link } from "react-router-dom";
import TableContainer from "../../../../components/Common/TableContainer";
import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import Select from "../../../../components/Common/custom-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FieldArray, Formik, useFormik,Form as FormFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-hot-toast";
import CustomSelect from "components/Common/custom-select";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { fetchCategories, fetchDepartments, fetchDesignations, fetchEmployeeDropdownAutoList, resetAll,fetchBiometricDevicePunch, fetchBiometricDiscrepancy,discrepancyShiftUpdate, discrepancyPunchUpdate, deleteMobilePunch  } from "store/actions";
import CustomDatePicker from "common/CustomDatePicker";
// import { fetchBiometricDevicePunch, fetchBiometricDiscrepancy,discrepancyShiftUpdate } from "store/attendance/biometric/actions";
import { convertToInputDate } from "common/dateFormat/formatDate";
import Swal from "sweetalert2";
import Loader from "common/pageLoader";
import CustomTimePicker from "common/CustomTimePicker";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import useButtonAccess from "components/Common/useButtonAccess";
import { getAttendanceSalaryDate } from "common/attendanceSalaryDate";


const employees = [
  { value: "001", label: "Arun" },
  { value: "003", label: "Ulaguraj" },
];

const punchData = [
  { id: 1, punchTime: "07:30 AM", order: 1 },
  { id: 2, punchTime: "08:45 AM", order: 2 },
  { id: 3, punchTime: "12:15 PM", order: 3 },
  { id: 4, punchTime: "03:50 PM", order: 4 },
];

const shiftOptions = [
  { value: "GS1", label: "GS1 (Shift Group)" },
  { value: "GS2", label: "GS2 (Shift Group)" },
];

const locationOptions = [
  { value: "office", label: "Office" },
  { value: "remote", label: "Remote" },
];

const defaultBreaks = {
  GS1: "1 Hour",
  GS2: "30 Minutes",
};

const sampleData = [
  {
    employee: "John Doe",
    punchDate: "2025-05-21",
    punchTime: "09:15 AM",
    location: "New York",
  },
  {
    employee: "Jane Smith",
    punchDate: "2025-05-21",
    punchTime: "09:12 AM",
    location: "San Francisco",
  },
];


const BiometricDiscrepancy = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const { canRead, canCreate, canEdit, canDelete } = useButtonAccess(accessRight);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const { 
    categories, 
    departments, 
    designations,
    discrepancyList,
    devicePunchList,
    dropdownAutoList,
    loading,
    success,
    error, 
  } = useSelector((state) => ({
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],
    designations: state.DesignationMaster?.designations ?? [],
    discrepancyList: state.AttendanceBiometricReducer?.discrepancyList ?? [],
    devicePunchList: state.AttendanceBiometricReducer?.devicePunchList ?? {},
    dropdownAutoList: state.EmployeeDetailsReducer?.dropdownAutoList ?? [],
    
    loading: state.AttendanceBiometricReducer?.loading || state.AttendanceTimeDeductionsReducer?.loading || state.CategoryMaster?.loading || state.DepartmentMaster?.loading || state.DesignationMaster?.loading || state.EmployeeDetailsReducer?.loading,
    error: state.AttendanceBiometricReducer?.error || state.AttendanceTimeDeductionsReducer?.error || state.CategoryMaster?.error || state.DepartmentMaster?.error || state.DesignationMaster?.error || state.EmployeeDetailsReducer?.error,
    success: state.AttendanceBiometricReducer?.success 
  })); 

  const { punch_details = [], shift_detail = [], location_List = [], puncht_date_List = [] } = devicePunchList || {};

  const shift_detail_options = (shift_detail || []).map(item => ({ value: item.shift_id.toString(), label: item.shift_name }))

  useEffect(() => {
      if (authDetails) {
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
    }, [authDetails]);

  useEffect(() => {
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
    dispatch(fetchDesignations(unitId));
    dispatch(fetchEmployeeDropdownAutoList(unitId))
    // dispatch(fetchShiftLate(unitId))
  }, [dispatch]);
  
  useEffect(()=>{
    if(puncht_date_List && puncht_date_List.length > 0){
      setSelectedShift(puncht_date_List[0])
    }
  },[puncht_date_List])

  useEffect(()=>{
    if(discrepancyList && discrepancyList.length > 0){
      setDiscrepancyPunchList(discrepancyList)
    }else{
      setDiscrepancyPunchList([])
    }
  },[discrepancyList])

  useEffect(() => {
      if(success){
        formik.resetForm()
        setModal(false);
        setDiscrepancyPunchList([])
        getAttendanceSalaryDate(authDetails.unit_id).then(response => {
          if (response.status === "success" && response.data.length > 0) {
            const data = response.data[0];
            formik.setFieldValue("fromDate", data.from_date.split('/').reverse().join('-'));
            formik.setFieldValue("toDate", data.to_date.split('/').reverse().join('-'));
          }
        });
      }
  }, [authDetails,success,dispatch]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [punchDate, setPunchDate] = useState(new Date());
  const [modal, setModal] = useState(false);
  const [selectedPunches, setSelectedPunches] = useState([]);
  const [selectedTime, setSelectedTime] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedShift, setSelectedShift] = useState();
  const [rows, setRows] = useState([]);
  const [devicepunchModalOpen, setDevicepunchModalOpen] = useState(false);
  const [discrepancyPunchList, setDiscrepancyPunchList] = useState([]);

  const validationSchema = Yup.object({
    // department:Yup.object().required("Department is required"),
    fromDate: Yup.date().nullable()
      .required("From Date is required"),

    toDate: Yup.date().nullable()
      .required("To Date is required")
      .test(
        "is-before-fromDate",
        "To Date must be greater than or equal to From Date",
        function (value) {
          const { fromDate } = this.parent;
          return !fromDate || !value || new Date(value) >= new Date(fromDate);
        }
      )
      // .test(
      //   "is-within-one-month",
      //   "To Date cannot be more than 1 month after From Date",
      //   function (value) {
      //     const { fromDate } = this.parent;
      //     if (!fromDate || !value) return true;
      //     const maxDate = new Date(fromDate);
      //     maxDate.setMonth(maxDate.getMonth() + 1);
      //     return new Date(value) <= maxDate;
      //   }
      // ),
  });

const formik = useFormik({
  initialValues: {
    category: "",
    department: "",
    designation: "",
    employeeName:"",
    employeeCode:"",
    fromDate: "",
    toDate: "",
    employee: "",
  },
  validationSchema,
  onSubmit: (values) => {
    const formData = new FormData();
    formData.append(
        "cat_id", 
        values.category && values.category.length ? values.category.map(item => item.value).join(",") : '0'
    );
    formData.append(
        "dept_id", 
        values.department && values.department.length ? values.department.map(item => item.value).join(",") : '0'
    );
    formData.append(
        "design_id", 
        values.designation && values.designation.length ? values.designation.map(item => item.value).join(",") : '0'
    );
    formData.append("emp_no", values.employeeCode);
    formData.append("emp_name", values.employeeName);
    formData.append("from_date", values.fromDate);
    formData.append("to_date", values.toDate);

    formData.append(
        "emp_id", 
        values.employee?.value || '0'
    );

    formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);
    
      dispatch(fetchBiometricDiscrepancy(formData));      
    },
  });

  const handleAddRow = () => {
    const newRows = [
      ...punchDetailsData,
      {
        post_id: Date.now(),
        shift_timings: selectedShift?.label || "",
        break_timings: selectedShift?.value || "",
        location_id: null,
        punch_time: "",
        punch_order: "",
        remarks: "",
      },
    ];

    // Recalculate order
    setPunchDetailsData(newRows.map((row, index) => ({ ...row, punch_order: index + 1 })));
  };

  const handleRemoveRow = (indexToRemove) => {
    const newRows = punchDetailsData.filter((_, i) => i !== indexToRemove);

    // Recalculate order
    setPunchDetailsData(newRows.map((row, index) => ({ ...row, punch_order: index + 1 })));
  };

  const handleInputChange = (index, field, value) => {
    const updatedRows = [...punchDetailsData];
    updatedRows[index][field] = value;
    setPunchDetailsData(updatedRows);
  };

  const handleSearch = () => {
    if (!selectedEmployee) {
      toast.error("Please select Employee");
      return;
    }
    // handleCloseModal();
  };

  const handleCheckboxChange = (id) => {
    setSelectedPunches((prev) =>
      prev.includes(id) ? prev.filter((punch) => punch !== id) : [...prev, id]
    );
  };

  const handleSave = (values, { setSubmitting }) => {
    console.log("Saved:", values);
    setSubmitting(false);
    handleCloseModal();
  };

  const punchValidationSchema = Yup.object().shape({
    shift_id: Yup.string().required("Shift is required"),
    punch_details: Yup.array().of(
      Yup.object().shape({
        location_id: Yup.string().required("Location is required"),
        punch_time: Yup.string()
          .required("Time is required")
          .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, "Invalid time format (HH:mm)"),
        punch_order: Yup.number()
          .typeError("Order must be a number")
          .positive("Order must be positive")
          .required("Order is required"),
        remarks: Yup.string().nullable(),
      })
    ),
  });

  const handleEdit = (rowData) => {
    setModal(true);
    setPunchDetailsData([])
    const formData = new FormData();
    formData.append("emp_id", rowData?.emp_id);
    formData.append("punch_date", convertToInputDate(rowData?.punch_date));
    formData.append("unit_id", authDetails?.unit_id);
    formData.append("create_by", authDetails?.user_id);
    dispatch(fetchBiometricDevicePunch(formData));
  };

  const handleCloseModal = () => {
    setModal(false); // always close
  };

//  const columns = [
//    {
//       Header: "Action",
//       Cell: (cellProps) => {
//         const uniqueId = `edittooltip-${cellProps.row.index}`;

//         return (
//           <div className="d-flex gap-3">
//             <button
//               id={uniqueId}   // attach id here, not on <i>
//               type="button"
//               className="btn btn-link text-success p-0"
//               onClick={() => handleEdit(cellProps.row.original)}
//             >
//               <i className="bx bxs-edit font-size-18" />
//             </button>
//             <UncontrolledTooltip placement="top" target={uniqueId}>
//               Edit
//             </UncontrolledTooltip>
//           </div>
//         );
//       }
//     },
//     { Header: "S.No", Cell: ({ row }) => discrepancyPunchList.length - row.index, className: "serial-no", applyHeaderClass: true, },
//     { Header: "Code", accessor: "emp_no" },
//     { Header: "Name", accessor: "emp_name" },
//     { Header: "Category", accessor: "category" },
//     { Header: "Department", accessor: "department" },
//     { Header: "Shift", accessor: "shift_time" },
//     { Header: "Date", accessor: "punch_date" },
//     { Header: "Punches", accessor: "punch_time" },    
//   ];

const columns = useMemo(() => {
  const cols = [];

  // 👉 Show Action Column ONLY if canEdit = true
  if (canEdit) {
    cols.push({
      Header: "Action",
      
      Cell: (cellProps) => {
        const uniqueId = `edittooltip-${cellProps.row.index}`;

        return (
          <div className="d-flex gap-3">
            <button
              id={uniqueId}
              type="button"
              className="btn btn-link text-success p-0"
              onClick={() => handleEdit(cellProps.row.original)}
            >
              <i className="bx bx-time-five font-size-18" />
            </button>

            <UncontrolledTooltip placement="top" target={uniqueId}>
              Punch Details
            </UncontrolledTooltip>
          </div>
        );
      },
    });
  }

  // 👉 Always Visible Columns
  cols.push(
    {
      Header: "S.No",
      Cell: ({ row }) => discrepancyPunchList.length - row.index,
      className: "serial-no",
      applyHeaderClass: true,
    },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Category", accessor: "category" },
    { Header: "Department", accessor: "department" },
    { Header: "Shift", accessor: "shift_time" },
    { Header: "Date", accessor: "punch_date" },
    { Header: "Punches", accessor: "punch_time" }
  );

  return cols;
}, [canEdit, discrepancyPunchList]);
  
  const columns_device_punches = [
  {
    Header: "Employee",
    accessor: "employee",
  },
  {
    Header: "Punch Date",
    accessor: "punchDate",
  },
  {
    Header: "Punch Time",
    accessor: "punchTime",
  },
  {
    Header: "Location",
    accessor: "location",
  },
];

  const data = [
    { code: "001", name: "Arun", punchDate: "04.10.24", punchTime: "7:30AM", enteredBy: "AES ADMIN", enteredOn: "16.10.24 08:25:19", remarks: "test" },
    { code: "003", name: "Ulaguraj", punchDate: "03.12.24", punchTime: "5:00PM", enteredBy: "", enteredOn: "17.12.24 18:35:54", remarks: "ok" },
  ];

  const handleCancel = () => {
    formik.resetForm();
    dispatch(resetAll())
  };

  const handleView = (row) => {
    // const formData = new FormData();
    // formData.append("emp_id",row?.emp_id)
    // formData.append("punch_date",'2025-01-21')
    // formData.append("unit_id",authDetails?.unit_id)
    // formData.append("create_by",authDetails?.user_id)
    // dispatch(fetchBiometricDevicePunch(formData))
    setDevicepunchModalOpen(true);
  };

  const toggledevicePunchModal = () => {
    setDevicepunchModalOpen(!devicepunchModalOpen);
  };


  const [punchDetailsData, setPunchDetailsData] = useState([]);

  useEffect(() => {
    if (punch_details && punch_details.length > 0) {
      setPunchDetailsData(punch_details)
    }
  }, [punch_details])

  const formatTimeWithColon = (val) => {
    const digits = val.replace(/\D/g, "").slice(0, 4);
    if (digits.length <= 2) return digits;
    return `${digits.slice(0, 2)}:${digits.slice(2)}`;
  };

  const timeToMinutes = (time) => {
    if (!time || typeof time !== "string" || !time.includes(":")) {
      return 0;
    }
    const [hours, minutes] = time.split(':').map(Number);
    return (isNaN(hours) ? 0 : hours) * 60 + (isNaN(minutes) ? 0 : minutes);
  };


  const handleHourChange = (value, rowIndex) => {
    if (!value) return;

    let input = value.trim();

    // Normalize input if colon is missing
    if (!input.includes(":")) {
      const digitsOnly = input.replace(/\D/g, "");

      if (digitsOnly.length === 1) {
        input = `0${digitsOnly}:00`; // "3" → "03:00"
      } else if (digitsOnly.length === 2) {
        input = `${digitsOnly}:00`; // "12" → "12:00"
      }
    }

    const formatted = formatTimeWithColon(input); // Formats to "HH:MM"

    const updated = [...punchDetailsData];

    // Validate final format and time bounds
    if (!formatted || !/^\d{2}:\d{2}$/.test(formatted)) {
      updated[rowIndex].punch_time = '';
      setPunchDetailsData(updated);
      return;
    }

    const [hours, minutes] = formatted.split(":").map(Number);

    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) {
      Swal.fire({
        icon: 'error',
        title: 'Invalid Time',
        text: 'Please enter a time between 00:00 and 23:59.',
      });
      updated[rowIndex].punch_time = ''; // Clear the field
      setPunchDetailsData(updated);
      return;
    }

    updated[rowIndex].punch_time = formatted;
    setPunchDetailsData(updated);
  };
  
  return (
    <React.Fragment>
      <div className="page-content">
        <Loader loading={loading}/>
        <Container fluid>
          <Breadcrumbs title="Biometric" breadcrumbItem="Discrepancy" />

          <Card>
            <CardBody>
              <Form onSubmit={formik.handleSubmit}>
                <Row>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="category">Category</Label>
                      <CustomSelect
                        id="category"
                        name="category"
                        options={categories.map(cat => ({ value: cat.empCatgryid.toString(), label: cat.empCategory }))}
                        value={formik.values.category || null}
                        onChange={(selectedOption) => formik.setFieldValue("category", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.category && formik.errors.category ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.category && formik.errors.category && (
                        <div className="text-danger">{formik.errors.category}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="department">Department</Label>
                      <CustomSelect
                        id="department"
                        name="department"
                        options={departments.map(cat => ({ value: cat.departmentId.toString(), label: cat.departmentname }))}
                        value={formik.values.department || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("department", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.department && formik.errors.department ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.department && formik.errors.department && (
                        <div className="text-danger">{formik.errors.department}</div>
                      )}
                    </FormGroup>
                  </Col>
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="designation">Designation</Label>
                      <CustomSelect
                        id="designation"
                        name="designation"
                        options={designations.map(cat => ({ value: cat.desig_id.toString(), label: cat.designation }))}
                        value={formik.values.designation || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("designation", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.designation && formik.errors.designation ? 'is-invalid' : ''}
                        isMulti
                      />
                      {formik.touched.designation && formik.errors.designation && (
                        <div className="text-danger">{formik.errors.designation}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employeeName">Employee Name</Label>
                      <Input
                        type="text"
                        name="employeeName"
                        id="employeeName"
                        value={formik.values.employeeName}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.employeeName && formik.errors.employeeName ? "is-invalid" : ""}`}
                      />
                      {formik.touched.employeeName && formik.errors.employeeName && (
                        <div className="text-danger">{formik.errors.employeeName}</div>
                      )}
                    </FormGroup>
                  </Col>

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employeeCode">Employee Code</Label>
                      <Input
                        type="text"
                        name="employeeCode"
                        id="employeeCode"
                        value={formik.values.employeeCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`form-control ${formik.touched.employeeCode && formik.errors.employeeCode ? "is-invalid" : ""}`}
                      />
                      {formik.touched.employeeCode && formik.errors.employeeCode && (
                        <div className="text-danger">{formik.errors.employeeCode}</div>
                      )}
                    </FormGroup>
                  </Col> */}

                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="employee">Employee</Label>
                      <CustomSelect
                        id="employee"
                        name="employee"
                        options={dropdownAutoList.map(cat => ({ value: cat.emp_id.toString(), label: cat.emp_no }))}
                        value={formik.values.employee || null}  // Store full object
                        onChange={(selectedOption) => formik.setFieldValue("employee", selectedOption)}
                        onBlur={formik.handleBlur}
                        className={formik.touched.employee && formik.errors.employee ? 'is-invalid' : ''}                        
                      />
                      {formik.touched.employee && formik.errors.employee && (
                        <div className="text-danger">{formik.errors.employee}</div>
                      )}
                    </FormGroup>
                  </Col>


                  {/* From Date */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="fromDate">From Date <span className="text-danger">*</span></Label>
                      <CustomDatePicker
                        name="fromDate"
                        value={formik.values.fromDate}
                        onChange={(date) => formik.setFieldValue("fromDate", date)}
                        onBlur={formik.handleBlur}
                        disableFuture={true}
                        className={`form-control ${formik.touched.fromDate && formik.errors.fromDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.fromDate && formik.errors.fromDate && (
                        <div className="text-danger">{formik.errors.fromDate}</div>
                      )}
                    </FormGroup>
                  </Col>

                  {/* To Date */}
                  <Col md={3} sm={12} className="mb-3">
                    <FormGroup>
                      <Label for="toDate">To Date <span className="text-danger">*</span></Label>
                        <CustomDatePicker
                        name="toDate"
                        value={formik.values.toDate}
                        onChange={(date) => formik.setFieldValue("toDate", date)}
                        onBlur={formik.handleBlur}
                        disableFuture={true}
                        className={`form-control ${formik.touched.toDate && formik.errors.toDate ? "is-invalid" : ""}`}
                      />
                      {formik.touched.toDate && formik.errors.toDate && (
                        <div className="text-danger">{formik.errors.toDate}</div>
                      )}
                    </FormGroup>
                  </Col>
                  
                  {/* Buttons */}
                  <Col className="d-flex align-items-center justify-content-end mob-center">
                   <Button type="submit" className="btn button-search me-2">
                                             <i className="fas fa-search me-1" /> Search
                                           </Button>
                    <Button type="button"  onClick={handleCancel} className="btn button-cancel"> <i className="fas fa-sync me-1" /> Cancel
                                      </Button>
                  </Col>
                </Row>
              </Form>
            </CardBody>
          </Card>


          {/* Punch Data Table */}
          <Card>
            <CardBody>
              <TableContainer columns={columns} data={discrepancyPunchList && discrepancyPunchList.length > 0 ? discrepancyPunchList:[]} isGlobalFilter={true} customPageSize={10} />
            </CardBody>
          </Card>
        </Container>

          {modal && selectedShift && shift_detail?.length && location_List?.length && punchDetailsData?.length && (
          <TimingsModal
            modal={modal}
            handleCloseModal={handleCloseModal}
            shift_detail={shift_detail}
            location_List={location_List}
            punchDetailsData={punchDetailsData}
            selectedShift={selectedShift}
            setSelectedShift={setSelectedShift}
            authDetails={authDetails}
            dispatch={dispatch}
            canEdit={canEdit}
            canDelete={canDelete}
          />
        )}

        {/* <Modal isOpen={devicepunchModalOpen} toggle={toggledevicePunchModal} size="lg">
            <ModalHeader toggle={toggledevicePunchModal}>Device Punches</ModalHeader>
            <ModalBody>
              <TableContainer data={sampleData} columns={columns_device_punches} isGlobalFilter={false} tableSorter={false} customPageSize={10}/>
            </ModalBody>
          </Modal> */}
      </div>
    </React.Fragment>
  );
};


const TimingsModal = ({
  modal,
  handleCloseModal,
  shift_detail,
  location_List,
  punchDetailsData,
  selectedShift,
  setSelectedShift,
  authDetails,
  dispatch,
  canEdit,
  canDelete,
}) => {

  const shift_detail_options = (shift_detail || []).map(item => ({ value: item.shift_id.toString(), label: item.shift_name }))
  const location_List_options = (location_List || []).map(item => ({ value: item.device_id.toString(), label: item.location }))
  // Formik Validation Schema
  const validationSchema = Yup.object().shape({
    shift_id: Yup.string().required("Shift is required"),
    punch_details: Yup.array().of(
      Yup.object().shape({
        // location_id: Yup.string().required("Location is required"),
        punch_time: Yup.string().nullable()
          .required("Time is required")
          .matches(/^([01]\d|2[0-3]):([0-5]\d)$/, "Invalid time format (HH:mm)"),
        punch_order: Yup.number()
          .typeError("Order must be a number")
          .positive("Order must be positive")
          .required("Order is required")
          .test("unique", "Punch order must be unique", function (value) {
            const punchDetails = this.options.context?.punch_details || [];
            const numValue = Number(value);
            const count = punchDetails.filter(
              (d) => Number(d.punch_order) === numValue
            ).length;
            return count <= 1;
          }),
        remarks: Yup.string().nullable().required("Remarks is required"),
      })
    ),
  });

  // Initial form values
  const initialValues = {
    shift_id: selectedShift?.shift_id || "",
    punch_date: selectedShift?.punch_date || "",
    group_name: selectedShift?.group_name || "",
    punch_details: punchDetailsData || [],
  };

  return (
    <Modal isOpen={modal} toggle={handleCloseModal} size="xl">
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => {
          const items = {
            listdiscrepancypunch: (values.punch_details || []).map((row) => ({
              emp_id: row.emp_id,
              post_id: row.post_id || "0",
              punch_date: row.punch_date,
              punch_time: row.punch_time,
              punch_order: row.punch_order,
              remarks: row.remarks || "",
              location: row.location_id || "0",
            })),
          };

          const formData = new FormData();
          formData.append("shift_id", values.shift_id);
          formData.append("items", JSON.stringify(items));
          formData.append("unit_id", authDetails?.unit_id); 
          formData.append("create_by", authDetails?.user_id);
          formData.append("ip_address", "");

          // Dispatch your saga action
          dispatch(discrepancyPunchUpdate(formData));
        }}
      >
        {({ values, errors, touched, setFieldValue,setFieldTouched }) => (
          <FormFormik>
            <ModalHeader toggle={handleCloseModal}>Timings</ModalHeader>
            <ModalBody>
              {/* Shift Selection */}

              <div className="mb-3 p-3 bg-light rounded d-flex align-items-center gap-3">
              {/* Date Section */}
              <div className="d-flex align-items-center flex-grow-1">
                <strong className="me-2">Date:</strong>
                <span className="flex-fill text-start">{values.punch_date}</span>
              </div>

              {/* Shift Group Section */}
              <div className="d-flex align-items-center flex-grow-1">
                <strong className="me-2">Shift Group:</strong>
                <span className="flex-fill text-start">{values.group_name}</span>
              </div>

              {/* Shift Selection */}
              <div className="d-flex align-items-center flex-grow-1">
                <strong className="me-2">Shift:</strong>
                <div className="flex-fill">
                  <CustomSelect
                      options={(shift_detail || []).map((s) => ({
                        value: s.shift_id,
                        label: s.shift_name,
                      }))}
                      value={shift_detail_options.find(s => s.value === values.shift_id) || null}
                      onChange={async (option) => {
                        const result = await Swal.fire({
                          title: "Are you sure?",
                          text: "Changing the shift will update all punch details.",
                          icon: "warning",
                          showCancelButton: true,
                          cancelButtonText: "Cancel",
                          confirmButtonText: "Yes, change it!",
                        });

                        if (result.isConfirmed) {
                          // Update Formik field
                          setFieldValue("shift_id", option.value);

                          const shiftInfo = shift_detail.find((s) => s.shift_id === option.value);
                          if (shiftInfo) {
                            const updatedPunches = values.punch_details.map((row) => ({
                              ...row,
                              shift_timings: shiftInfo.shift_name,
                              break_timings: shiftInfo.break_hours,
                            }));
                            setFieldValue("punch_details", updatedPunches);
                          }

                          // Prepare FormData for API
                          const formData = new FormData();
                          formData.append("shift_id", option.value);
                          formData.append("emp_id", punchDetailsData[0]?.emp_id);
                          formData.append("punch_date", punchDetailsData[0]?.punch_date);
                          formData.append("unit_id", authDetails?.unit_id); 
                          formData.append("create_by", authDetails?.user_id); // or other info if needed

                          // Dispatch Redux action to trigger API
                          dispatch(discrepancyShiftUpdate(formData));
                        }
                      }}
                    />
                  {errors.shift_id && touched.shift_id && (
                    <div className="text-danger">{errors.shift_id}</div>
                  )}
                </div>
              </div>
            </div>

              {/* Punch Table */}
              <FieldArray name="punch_details">
                {({ remove, push }) => (
                  <Table bordered>
                    <thead>
                      <tr>
                        <th style={{ width: "5%", textAlign: "center" }}>
                          <i
                            className="mdi mdi-plus-circle text-primary"
                            style={{ cursor: "pointer", fontSize: "20px" }}
                            onClick={() => {
                              const shiftInfo = shift_detail.find((s) => s.shift_id === values.shift_id);
                              push({
                                emp_id: punchDetailsData[0]?.emp_id || "",
                                punch_date: punchDetailsData[0]?.punch_date || "",
                                shift_timings: shiftInfo?.shift_name || "",
                                break_timings: shiftInfo?.break_hours || "",
                                location_id: "",
                                punch_time: "",
                                punch_order: values.punch_details.length + 1,
                                remarks: "",
                              });
                            }}
                          />
                        </th>                  
                        <th style={{ width: "15%" }}>Shift</th>
                        <th style={{ width: "15%" }}>Break</th>
                        <th style={{ width: "20%" }}>Location</th>
                        <th style={{ width: "15%" }}>Time</th>
                        <th style={{ width: "10%" }}>Order</th>
                        <th style={{ width: "20%" }}>Remarks</th>
                      </tr>
                    </thead>
                    <tbody>
                      {values.punch_details.map((row, index) => (
                        <tr key={index}>
                          {/* <td style={{ textAlign: "center" }}>
                            <i
                              className="mdi mdi-close-circle text-danger"
                              style={{ cursor: "pointer" }}
                              onClick={() => remove(index)}
                            />
                          </td> */}
                          {canDelete ? (
                              <td style={{ textAlign: "center" }}>
                                {/* <i
                                  className="fas fa-trash text-danger"
                                  style={{ cursor: "pointer", fontSize: "20px" }}
                                  onClick={() => {
                                    // Remove the row
                                    const newDetails = [...values.punch_details];
                                    newDetails.splice(index, 1);

                                    // Reassign punch_order sequentially
                                    const updatedDetails = newDetails.map((row, i) => ({
                                      ...row,
                                      punch_order: i + 1, // auto-update order
                                    }));

                                    setFieldValue("punch_details", updatedDetails);
                                  }}
                                /> */}
                                <i
                                  className="fas fa-trash text-danger"
                                  style={{ cursor: "pointer", fontSize: "20px" }}
                                  onClick={() => {
                                    Swal.fire({
                                      title: "Are you sure?",
                                      text: "Do you want to delete this punch entry?",
                                      icon: "warning",
                                      showCancelButton: true,
                                      confirmButtonColor: "#3085d6",
                                      cancelButtonColor: "#d33",
                                      confirmButtonText: "Yes, delete it!",
                                    }).then((result) => {
                                      if (result.isConfirmed) {
                                        const postId = values.punch_details[index]?.post_id;

                                        const formData = new FormData();
                                          formData.append("post_id", postId);

                                        // If row has ID → call API delete
                                        if (postId) {
                                          dispatch(deleteMobilePunch(formData));
                                        }

                                        // Remove from UI immediately
                                        const updated = [...values.punch_details];
                                        updated.splice(index, 1);

                                        // Reassign punch_order
                                        const reordered = updated.map((item, idx) => ({
                                          ...item,
                                          punch_order: idx + 1,
                                        }));

                                        setFieldValue("punch_details", reordered);

                                        // Swal.fire("Deleted!", "Punch entry has been deleted.", "success");
                                      }
                                    });
                                  }}
                                />

                              </td>
                          ) : (
                            <td></td>  // 👈 show empty td when cannot delete
                          )}               

                          <td>{row.shift_timings}</td>
                          <td>{row.break_timings}</td>
                          <td>
                            <CustomSelect
                              options={location_List_options}
                              value={location_List_options.find(
                                s => s.value === values.punch_details[index].location_id?.toString()
                              ) || null}
                              onChange={(opt) =>
                                setFieldValue(
                                  `punch_details[${index}].location_id`,
                                  opt ? opt.value : ""  // <-- handle null when cleared
                                )
                              }
                              isClearable
                              isDisabled={!!row.post_id}

                            />
                            {errors.punch_details?.[index]?.location_id &&
                              touched.punch_details?.[index]?.location_id && (
                                <div className="text-danger">
                                  {errors.punch_details[index].location_id}
                                </div>
                            )}
                          </td>
                          <td>
                            <CustomTimePicker
                              value={values.punch_details[index].punch_time}
                              onChange={(val) =>
                                setFieldValue(`punch_details[${index}].punch_time`, val)
                              }
                              onBlur={() =>
                                setFieldTouched(`punch_details[${index}].punch_time`, true)
                              }
                              placeholder="HH:mm"
                              format="HH:mm" // 24-hour format, matches your Yup regex
                              disabled={!!row.post_id}
                            />
                            {errors.punch_details?.[index]?.punch_time &&
                              touched.punch_details?.[index]?.punch_time && (
                                <div className="text-danger">
                                  {errors.punch_details[index].punch_time}
                                </div>
                              )}
                          </td>
                          <td>
                            <Input
                              type="text"
                              value={values.punch_details[index].punch_order}
                              className="form-control"
                              style={{ width: "60px" }}
                              onChange={(e) =>
                                setFieldValue(
                                  `punch_details[${index}].punch_order`,
                                  e.target.value
                                )
                              }
                              
                            />
                            {errors.punch_details?.[index]?.punch_order &&
                              touched.punch_details?.[index]?.punch_order && (
                                <div className="text-danger">
                                  {errors.punch_details[index].punch_order}
                                </div>
                              )}
                          </td>
                          {/* <td style={{ textAlign: "center" }}>
                            <span>{index + 1}</span>
                          </td> */}
                          <td>
                            <input
                              type="text"
                              value={row.remarks}
                              className="form-control"
                              onChange={(e) =>
                                setFieldValue(
                                  `punch_details[${index}].remarks`,
                                  e.target.value
                                )
                              }
                            />
                            {errors.punch_details?.[index]?.remarks &&
                              touched.punch_details?.[index]?.remarks && (
                                <div className="text-danger">
                                  {errors.punch_details[index].remarks}
                                </div>
                              )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                )}
              </FieldArray>
            </ModalBody>

            <ModalFooter>
              <Button color="primary" type="submit">
                Update
              </Button>
              <Button color="secondary" onClick={handleCloseModal}>
                Cancel
              </Button>
            </ModalFooter>
          </FormFormik>
        )}
      </Formik>
    </Modal>
  );
};

export default BiometricDiscrepancy;
